import {ApolloClient, InMemoryCache, HttpLink} from '@apollo/client';

import {Stage} from '../common/constant';
import {getStage} from '../utils/helper';

import {getToken} from './getToken';

const stage = getStage();

export const getApiGatewayHeaders = async () => {
  const token = await getToken();

  return {
    'x-atoz-client-id': 'ATOZ_HVH_CAREERSITE_APPSYNC_SERVICE',
    Authorization: `Bearer ${token}`,
  };
};

const apiGatewayUrl: Record<Stage, string> = {
  [Stage.DEV]: 'https://atoz-api.integ.amazon.com',
  [Stage.BETA]: 'https://atoz-api.integ.amazon.com',
  [Stage.PROD]: 'https://atoz-api.amazon.work',
};

const apiGatewayReverseProxyUrl: Record<Stage, string> = {
  [Stage.DEV]: 'https://atoz.integ.amazon.com/apis/HVHCareerSite',
  [Stage.BETA]: 'https://atoz.integ.amazon.com/apis/HVHCareerSite',
  [Stage.PROD]: 'https://atoz-apps.amazon.work/apis/HVHCareerSite',
};

const getCredentials = (): string => (stage === Stage.DEV ? 'same-origin' : 'include');

export const getApiGatewayUrl = (stage: Stage, reverseProxyEnabled: boolean): string => {
  return `${reverseProxyEnabled ? apiGatewayReverseProxyUrl[stage] : apiGatewayUrl[stage]}/graphql`;
};

export const createHttpLink = async (reverseProxyEnabled: boolean) => {
  const headers = await getApiGatewayHeaders();

  return new HttpLink({
    uri: getApiGatewayUrl(stage, reverseProxyEnabled),
    headers,
    credentials: getCredentials(),
  });
};

export const getApolloClient = async (reverseProxyEnabled: boolean) => {
  const httpLink = await createHttpLink(reverseProxyEnabled);

  return new ApolloClient({
    link: httpLink,
    cache: new InMemoryCache(),
    connectToDevTools: true,
  });
};
